<template>
  <div>
    <v-row>

      <v-col sm="12" class="pb-0">
        <v-tabs>
          <v-tab @click="changeExhibitTypePlant">Высшее растение</v-tab>
          <v-tab @click="changeExhibitTypeLichen">Лишайник</v-tab>
        </v-tabs>
      </v-col>

      <v-col sm="4">
        <v-card height="100%" tile elevation="3" class="pa-5 pt-0 mt-2">
          <v-text-field
              autocomplete="off"
              v-model="exhibitObject.barcode"
              :rules="nameRules"
              required
              clearable
              name="barcode"
              class="rounded-0"
              label="штрихкод"
          />
          <v-text-field
              autocomplete="off"
              v-model="exhibitObject.family"
              clearable
              name="family"
              class="rounded-0"
              label="семейство"
          />
          <v-text-field
              autocomplete="off"
              v-model="exhibitObject.genus"
              clearable
              name="genus"
              class="rounded-0"
              label="род"
              @blur="getIndexByGenus"
          />
          <v-text-field
              autocomplete="off"
              v-model="exhibitObject.species"
              clearable
              name="species"
              class="rounded-0"
              label="вид"
          />
          <v-text-field
              autocomplete="off"
              v-model="exhibitObject.labelName"
              v-if="!isLichen"
              clearable
              name="labelName"
              class="rounded-0"
              label="название на этикетке"
          />
          <v-text-field
              autocomplete="off"
              v-model="exhibitObject.taxonomy"
              v-if="!isLichen"
              clearable
              name="taxonomy"
              class="rounded-0"
              label="таксономия по Catalogue of Life"
          />
          <v-text-field
              autocomplete="off"
              v-model="exhibitObject.synonym"
              v-if="!isLichen"
              clearable
              name="synonym"
              class="rounded-0"
              label="синонимы"
          />
          <v-text-field
              autocomplete="off"
              v-model="exhibitObject.taxonomy"
              v-if="isLichen"
              clearable
              name="taxonomy"
              class="rounded-0"
              label="принятый таксон"
          />
          <v-text-field
              autocomplete="off"
              v-model="exhibitObject.ecologicalCharacteristics"
              v-if="isLichen"
              clearable
              name="eco"
              class="rounded-0"
              label="экологическая характеристика места обитания"
          />
          <v-text-field
              autocomplete="off"
              v-model="exhibitObject.powotaxonomy"
              v-if="!isLichen"
              clearable
              name="powotaxonomy"
              class="rounded-0"
              label="таксономия по POWO"
          />
        </v-card>
      </v-col>

      <v-col sm="4">
        <v-card height="100%" tile elevation="3" class="pa-5 pt-0 mt-2">
          <v-text-field
              autocomplete="off"
              v-model="exhibitObject.russianName"
              v-if="!isLichen"
              clearable
              name="russianName"
              class="rounded-0"
              label="русское название"
          />
          <v-text-field
              autocomplete="off"
              v-model="exhibitObject.labelsCount"
              v-if="!isLichen"
              clearable
              name="labelsAmount"
              class="rounded-0"
              label="количество этикеток"
          />
          <date-period-component @emit-method-name="updateCollectionDate" label-text="дата сбора" />
          <v-text-field
              autocomplete="off"
              v-model="exhibitObject.collectors"
              clearable
              name="collectors"
              class="rounded-0"
              label="коллекторы"
          />
          <date-period-component @emit-method-name="updateDeterminationDate" label-text="дата определения" />
          <v-text-field
              autocomplete="off"
              v-model="exhibitObject.determinatedBy"
              clearable
              name="determinedBy"
              class="rounded-0"
              label="кем детерминировано"
          />
          <v-text-field
              autocomplete="off"
              v-model="exhibitObject.natureConservationStatus"
              clearable
              name="conservationStatus"
              class="rounded-0"
              label="природоохранный статус"
          />
          <v-text-field
              autocomplete="off"
              v-model="exhibitObject.numberOfHerbariumSheets"
              clearable
              name="numberOfHerbariumSheets"
              class="rounded-0"
              label="количество гербарных листов"
          />
          <v-text-field
              autocomplete="off"
              v-model="exhibitObject.note"
              v-if="isLichen"
              clearable
              name="note"
              class="rounded-0"
              label="примечание"
          />
        </v-card>
      </v-col>
      <v-col sm="4">
        <v-card height="100%" tile elevation="3" class="pa-5 mt-2">
          <v-textarea
              autocomplete="off"
              v-model="exhibitObject.labelText"
              name="labelText"
              dense
              outlined
              clearable
              class="rounded-0"
              label="текст этикетки"
              no-resize
              rows="3"
          />
          <v-text-field
              readonly
              autocomplete="off"
              v-model="exhibitObject.index"
              name="latitudeGPS"
              class="rounded-0 mt-0"
              label="индекс рода"
          />
          <v-text-field
              autocomplete="off"
              v-model="exhibitObject.submittedBy"
              name="insertedBy"
              clearable
              class="rounded-0"
              label="образец внес"
          />
          <v-text-field
              autocomplete="off"
              v-model="exhibitObject.gatheringPlaceDistrict"
              name="gatheringPlaceDistrict"
              clearable
              class="rounded-0"
              label="район сбора"
          />
          <v-text-field
              autocomplete="off"
              v-model="exhibitObject.gatheringPlaceRegion"
              name="gatheringPlaceRegion"
              clearable
              class="rounded-0"
              label="область/республика сбора"
          />
          <v-text-field
              autocomplete="off"
              v-model="exhibitObject.gatheringPlaceCountry"
              name="gatheringPlaceCountry"
              clearable
              class="rounded-0"
              label="страна сбора"
          />
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col sm="12">
        <v-card height="100%" tile elevation="3" class="pa-5 pt-2">
          <v-row no-gutters>
            <h4 class="mb-0 align-self-center">GPS-координаты</h4>
            <v-menu   offset-x
                      right
                      open-on-hover
                      :close-on-content-click="false"
            >
              <template #activator="{ on, attrs }">
                <v-btn plain class="ms-2" icon v-on="on">
                  <v-icon large color="red"> mdi-alert-outline </v-icon>
                </v-btn>
              </template>
              <v-card tile class="ma-0 pa-5">
                <v-card-title class="pa-0 pb-3">Рекомендуемый формат координат:</v-card-title>
                <p class="font-weight-bold">Градусы, минуты и секунды + доп. буквы</p>
                <p class="font-weight-bold">Примеры:</p>
                <p class="font-weight-bold">Широта: 53°30'14.13''N</p>
                <p class="font-weight-bold">Долгота: 48°52'56.29''E</p>
                <p class="color-primary">Корректное отображение координат в других форматах не гарантировано</p>
              </v-card>
            </v-menu>
          </v-row>
          <v-text-field
              autocomplete="off"
              v-model="exhibitObject.gps.latitude"
              name="latitudeGPS"
              clearable
              class="rounded-0 mt-0"
              label="широта"
          />
          <v-text-field
              autocomplete="off"
              v-model="exhibitObject.gps.longitude"
              name="longitudeGPS"
              clearable
              class="rounded-0"
              label="долгота"
          />
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {findGenusIndexByGenus} from "@/services/genusIndexAPI";
import ToastService from "@/services/toastService";
import DatePeriodComponent from "@/components/ExhibitCreationPageComponents/DatePeriodComponent.vue";

export default {
  name: "ExhibitInputs",

  data() {
    return {
      isLichen: false,
      valid: false,
      nameRules: [
        v => !!v || 'Поле не может быть пустым',
      ],

    }
  },

  props: {
    exhibitObject: {
      type: Object,
      required: true,
    }
  },
  
  components: {
    DatePeriodComponent
  },

  methods: {
    changeExhibitTypeLichen: function () {
      this.isLichen = true
      this.$emit('changePlantType', 'LICHEN')
    },
    changeExhibitTypePlant: function () {
      this.isLichen = false
      this.$emit('changePlantType', 'HIGHER_PLANT')
    },

    async getIndexByGenus() {
      if (this.exhibitObject.genus) {
        this.isLoading = true
        await findGenusIndexByGenus(this.exhibitObject.genus)
            .then((data) => {
              this.exhibitObject.index = data.index;
            })
            .catch((e) => {
              if (e.response.status === 404) {
                ToastService.toastError("Ошибка сервера")
              }
            })
            .finally(() => {
              this.isLoading = false
            })
      }
    },

    updateCollectionDate(startDateObj, endDateObj) {
      this.exhibitObject.collectionDate.startDate = startDateObj;
      this.exhibitObject.collectionDate.endDate = endDateObj;
    },

    updateDeterminationDate(startDateObj, endDateObj) {
      this.exhibitObject.determinationDate.startDate = startDateObj;
      this.exhibitObject.determinationDate.endDate = endDateObj;
    }
  }
}
</script>

<style scoped>

</style>